export default {"src":"/_next/static/media/le jeune.d27b8635.svg","height":88,"width":768};